import { render } from "./app.vue?vue&type=template&id=3c345515"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=3c345515&lang=scss"

import exportComponent from "/home/jenkins/agent/tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_22.13.1/lib/node_modules/@core/vue-cli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__